import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from './images/logo.png';

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollOrNavigate = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        setMobileMenuOpen(false);
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
          setMobileMenuOpen(false);
        }
      }, 50);
    }
  };

  const goTop = (path = '/') => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setMobileMenuOpen(false);
    }, 50);
  };

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-content">
          <Link to="/" className="logo" onClick={() => goTop('/')}>
            <div className="logo-icon">
              <img src={logo} width={40} height={40} alt="Logo" />
            </div>
            <div className="logo-text">
              <h1 className="logo-title">Dr. med. Lothar Boso</h1>
              <p className="logo-subtitle">Facharzt Innere Medizin und Rheumatologie</p>
            </div>
          </Link>

          <div className="nav-menu">
            <button onClick={() => scrollOrNavigate('leistungen')} className="nav-link">
              Leistungen
            </button>
            <button onClick={() => scrollOrNavigate('team')} className="nav-link">
              Team
            </button>
            <button onClick={() => goTop('/gallery')} className="nav-link">
              Galerie
            </button>
            <button onClick={() => goTop('/impressum')} className="nav-link">
              Impressum
            </button>
            <button onClick={() => goTop('/datenschutz')} className="nav-link">
              Datenschutz
            </button>
            <button onClick={() => goTop('/')} className="nav-cta">
              Startseite
            </button>
          </div>

          <button 
            className="mobile-menu-button" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => scrollOrNavigate('leistungen')} className="nav-link">
            Leistungen
          </button>
          <button onClick={() => scrollOrNavigate('team')} className="nav-link">
            Team
          </button>
          <button onClick={() => goTop('/gallery')} className="nav-link">
            Galerie
          </button>
          <button onClick={() => goTop('/impressum')} className="nav-link">
            Impressum
          </button>
          <button onClick={() => goTop('/datenschutz')} className="nav-link">
            Datenschutz
          </button>
          <button onClick={() => goTop('/')} className="nav-cta">
            Startseite
          </button>
        </div>
      )}
    </nav>
  );
}